import { render, staticRenderFns } from "./structured_p.vue?vue&type=template&id=714aea1c&scoped=true"
import script from "./structured_p.vue?vue&type=script&lang=js"
export * from "./structured_p.vue?vue&type=script&lang=js"
import style0 from "./structured_p.vue?vue&type=style&index=0&id=714aea1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714aea1c",
  null
  
)

export default component.exports